module.exports = __webpack_public_path__ + "media/images/result_sets/circles/9r8n3n6r-7ac75a44f2c0d4ddeea1eb2edcb5e453.svg";